import script from "./rec-progress-bar.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-progress-bar.vue?vue&type=script&lang=ts&setup=true"

import "./rec-progress-bar.vue?vue&type=style&index=0&id=3b53d690&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b53d690"]])

export default __exports__